import { Bots } from '@/app/pages/LandingPage/Bots/Bots'
import { Hero } from '@/app/pages/LandingPage/Hero/Hero'
import { MatrixSection } from '@/app/pages/LandingPage/MatrixSection/MatrixSection'
import { NatalSection } from '@/app/pages/LandingPage/NatalSection/NatalSection'
import { Prices } from '@/app/pages/LandingPage/Prices/Prices'
import { metrikaHit } from '@/app/utils/metrika'
import type { FunctionalComponent } from 'preact'
import { useEffect } from 'preact/hooks'
import styles from './index.module.scss'

export const LandingPageV2: FunctionalComponent = () => {
  useEffect(() => {
    metrikaHit()
  }, [])

  return (
    <div class={styles.root}>
      <Hero />

      <section class={styles.section}>
        <Bots />
      </section>

      <section class={styles.section}>
        <NatalSection />
      </section>

      <section class={styles.section}>
        <MatrixSection />
      </section>

      <section class={styles.section}>
        <Prices />
      </section>
    </div>
  )
}
